

export function RemoveSession() {
    if (sessionStorage.getItem("#_state")) {
        sessionStorage.removeItem("#_state");
        sessionStorage.removeItem("#_history");
        sessionStorage.removeItem("#_clientId");
    }
}